/**
 * @description 前端监控 SDK 多环境配置
 * @reason projectId/secretKey/endpoint 在插件中由 runtimeConfig.public 注入（.env 经 Nuxt 注入），此处仅作默认
 */
export default {
  common: {
    apiPrefix: '/monitorApi',

    enableError: true,
    enablePerformance: true,
    enableBreadcrumb: true,
    enableEvent: true,
    enableNetworkCapture: true,
    enableStabilityCheck: true,
    enableWhiteScreenCheck: true,
    enableLongTask: true,
    enableAutoPageView: false,
    enableAutoClick: false,

    sampleRate: 1,
    bufferSize: 10,
    bufferFlushMs: 5000,
    maxBreadcrumbs: 5,
    denyUrls: ['chrome-extension://', 'moz-extension://'],
  },

  development: {
    sampleRate: 1,
    enableAutoClick: true,
    enableLongTask: false,
  },

  test: {
    sampleRate: 1,
    enableAutoClick: false,
  },

  production: {
    sampleRate: 0.9,
    enableAutoClick: false,
    enableLongTask: true,
  },
}
